if (typeof window.customElements === "undefined") {
    document.write('<script src="//unpkg.com/document-register-element"></script>');
}

export { };

